import Icon1 from '../assets/images/icon-1.png';
import Icon2 from '../assets/images/icon-2.png';
import Icon3 from '../assets/images/icon-3.png';
export const MIN_SIP_AMT = 10000;
export const MIN_LUMPSUM_AMT = 40000;

export const Msg = {
    panNo: "Invalid Pan Number",
    mobileNo: 'Invalid Mobile No',
    otp: "Invalid OTP",
}

export const logInMenuItemValues = {
    mutualFund: "mutualFund",
    pms: "pms",
    distributor: "distributor"
};

export const loginOptions = {
    otp: "otp",
    password: "password"
};

//#region Maintain these value with server data value
export const loginMode = {
    PANNO: 1,
    UserId: 2,
    MobileNo: 3,
    EmailId: 4,
    FolioNo: 5
};

export const credentialMode = {
    otp: 1,
    password: 2,
    mPin: 3
}
//#endregion

export const regEx = {
    number: /^[0-9\b]+$/,
    panRegex: /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
    userIdRegex: /^([a-zA-Z]){1}[0-9]*$/,
    numberWithEmptyString: /^[0-9]*$/,
    mobileNumber: /^[6-9]\d{9}$/,
    otpRegex: /^[0-9]*$/,
    email: /^[a-zA-Z0-9._!#$&'*\/=?^`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
    alphaNumeric: /^[a-zA-Z0-9]*$/,
    alphaNumericHyphen: /^[a-zA-Z0-9-]*$/,
    alphaNumericWithSpace: /^[a-zA-Z0-9 ]*$/,
    alphaNumericWithSingleSpace: /^[a-z|A-Z|0-9]+(?: [a-z|A-Z|0-9]+)*$/,
    alphabates: /^[a-zA-Z]*$/,
    alphabatesWithSpace: /^[a-zA-Z ]*$/,
    float: /^\d+(\.\d+)?$/,
    numberWithSingleDecimal: /^[0-9]*\.?[0-9]*$/,
    alphaNumericWithHypen: /^[a-zA-Z0-9-]*$/,
    alphaNumericAdd: /^[a-zA-Z0-9\s,-]*$/,
    alphaNumericMandatory: /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/,
    indianMobileNumber: /^(\+91[\-\s]?)?[0]?(91)?[6789]\d{9}$/,
    noSpecialCharacters: /^[^*|\":<>[\]{}`\\()';@&$]+$/,
    emailRegex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    drivingLicenseRegex: /^[A-Z]{2}[0-9]{13}$/,
    passportRegex: /^[A-Z]{1}[0-9]{7}$/,
}

// Mandate submenus configuration for UPI mandate registration
export const MANDATE_SUBMENUS = [
    {
        id: 'UPI',
        value: 'UPI',
        label: 'UPI',
        name: 'UPI',
        enabled: true
    },
    {
        id: 'NET_BANKING',
        value: 'NET BANKING',
        label: 'NET BANKING',
        name: 'NET BANKING',
        enabled: true
    },
    {
        id: 'DEBIT_CARD',
        value: 'Debit Card',
        label: 'Debit Card',
        name: 'Debit Card',
        enabled: true
    }
];



/* all info read while submitting switch */
const SUBMIT_TEXT = `I/we have and understand the content of the SID/SAI &amp; KIM of the
respective Scheme(s) and agreeto abide by the terms and conditions mentioned
therein and agree to receive all communications from Motilal Oswal Mutual Fund to
the registered Email Id / Mobile Number in my folio(s).`

export const SWITCH_SUBMIT = {
    text: SUBMIT_TEXT,
    label: "Yes, Switch Fund",
    name: 'switchFund',
    value: 'switchFund'
}
/* */
export const STP_SUBMIT = {
    text: SUBMIT_TEXT,
    label: "Yes, STP Fund",
    name: 'STPFund',
    value: 'STPFund'
}

export const REDEEM_SUBMIT = {
    text: SUBMIT_TEXT,
    label: "Proceed",
    name: 'Proceed',
    value: 'Proceed'
}




/*euin declaration */
export const EUIN_DECLARE_TEXT = ` I/We hereby confirm that the EUIN box has been intentionally
left blank by me/us as this transacation is an executed without any
interaction oradvice by the employee/relationship manager/sales person
of th above distributor/sub broker or notwithstanding the advice of in-approateness,
if any, provided by the employee/relationship
manager/sales person of the distributor/sub broker.`


export const patternType = {
    alphaNumeric: 'alphaNumeric',
    alphabates: 'alphabates',
    numeric: 'numeric',
    float: 'float'
}

export const transactType = {
    switch: 'switch',
    redeem: 'redeem',
    stp: 'stp'
}

export const dateValidationText = {
    minDate: 'STP start date cannot be before ',
    fromDate: 'From Date cannot be greater than To Date',
    fromDateEqual: 'To Date cannot be equal to From Date',
    dateFrequency: 'Number of Installments cannot be less than '
}

export const stpValidationText = {
    minSchemeAmount: 'Your amount should be greater than '
}

export const responseError = {
    requestFail: "Something went wrong"
}

export const redeemPages = {
    redeem: 'redeem',
    confirm: 'confirm',
    redemption: 'redemption',
    success: 'success',
}

export const redeemPagesSequence = [redeemPages.redeem, redeemPages.confirm, redeemPages.redemption, redeemPages.success]

export const stpPages = {
    stpStaticPage: 'stpStaticPage',
    success: 'success',
}

export const stpPagesSequence = [stpPages.stpStaticPage, stpPages.success]

export const switchPages = {
    from: 'from',
    to: 'to',
    success: 'success',
}

export const switchPagesSequence = [switchPages.from, switchPages.to, switchPages.success]

export const trans = {
    returnUrl: process.env.PG_RETURN_URL,
    // returnUrl: 'http://localhost:8080/paymentResponse',
}

export let paymentType = [
    {
        name: "Net Banking",
        mode: 'DCB',
        image: Icon1,
        chequeType: "DCB",
    },
    {
        name: "UPI",
        mode: 'UPI',
        image: Icon2,
        chequeType: "UPI",
    }, {
        name: "IMPS ",
        mode: 'IMPS',
        image: Icon3,
        chequeType: "IMPS",
    },
    {
        name: "NEFT/RTGS ",
        mode: 'RTGS',
        image: Icon3,
        chequeType: "RTGS",
    },
    {
        name: "Auto Pay",
        mode: 'OTM',
        image: Icon3,
        chequeType: "OTM",
    }
];

export let lumsumNRE = [
    {
        name: "Net Banking",
        mode: 'DCB',
        image: Icon1,
        chequeType: "DCB",
    },
    {
        name: "UPI",
        mode: 'UPI',
        image: Icon2,
        chequeType: "UPI",
    }, {
        name: "IMPS ",
        mode: 'IMPS',
        image: Icon3,
        chequeType: "IMPS",
    },
    {
        name: "NEFT/RTGS ",
        mode: 'RTGS',
        image: Icon3,
        chequeType: "RTGS",
    }
];

export let paymentTypeWithoutOtm = [
    {
        name: "Net Banking",
        mode: 'DCB',
        image: Icon1,
        chequeType: "DCB",
    },
    {
        name: "UPI",
        mode: 'UPI',
        image: Icon2,
        chequeType: "UPI",
    }, {
        name: "IMPS ",
        mode: 'IMPS',
        image: Icon3,
        chequeType: "IMPS",
    },
    {
        name: "NEFT/RTGS ",
        mode: 'RTGS',
        image: Icon3,
        chequeType: "RTGS",
    }
];

export let payTypeGreaterOneLakh = [
    {
        name: "Net Banking",
        mode: 'DCB',
        image: Icon1,
        chequeType: "DCB",
    }, {
        name: "IMPS ",
        mode: 'IMPS',
        image: Icon3,
        chequeType: "IMPS",
    },
    {
        name: "NEFT/RTGS ",
        mode: 'RTGS',
        image: Icon3,
        chequeType: "RTGS",
    },
    {
        name: "Auto Pay",
        mode: 'OTM',
        image: Icon3,
        chequeType: "OTM",
    }
]

export let payTypeGreaterOneLakhNRE = [
    {
        name: "Net Banking",
        mode: 'DCB',
        image: Icon1,
        chequeType: "DCB",
    }, {
        name: "IMPS ",
        mode: 'IMPS',
        image: Icon3,
        chequeType: "IMPS",
    },
    {
        name: "NEFT/RTGS ",
        mode: 'RTGS',
        image: Icon3,
        chequeType: "RTGS",
    }
]

export const sinPaymentType = [//sin pay mode
    {
        name: "Net Banking + Auto Pay",
        mode: 'Mandate',
        image: Icon1,
        chequeType: "Mandate",
    },
    {
        name: "UPI + Auto Pay",
        mode: 'UPI',
        image: Icon2,
        chequeType: "OTM",
    },
    {
        name: "Auto Pay",
        mode: 'OTM',
        image: Icon3,
        chequeType: "OTM",
    }
];

export const sipPaymentType = [//sip pay mode
    {
        name: "Auto Pay",
        mode: 'Mandate',
        image: Icon1,
        chequeType: "OTM",
    }
];

export const nroType = [
    {
        name: "Netbanking + Add Biller",
        mode: 'DCB',
        image: Icon1,
        chequeType: "DCB",
    },
    {
        name: "UPI + Biller",
        mode: 'UPI',
        image: Icon2,
        chequeType: "DCB",
    }
]

export const nrosipType = [
    {
        name: "Add Biller",
        mode: 'DCB',
        image: Icon1,
        chequeType: "DCB",
    }
]

export const NrosipAllPaymentType = [
    {
        name: "Auto Pay",
        mode: 'Mandate',
        image: Icon1,
        chequeType: "OTM",
    },
    {
        name: "Add Biller",
        mode: 'DCB',
        image: Icon1,
        chequeType: "DCB",
    }
]

//if user having otm details then use this
export const NroAllPaymentType = [
    {
        name: "Net Banking + Auto Pay",
        mode: 'Mandate',
        image: Icon1,
        chequeType: "Mandate",
    },
    {
        name: "UPI + Auto Pay",
        mode: 'UPI',
        image: Icon2,
        chequeType: "OTM",
    },
    {
        name: "Auto Pay",
        mode: 'OTM',
        image: Icon1,
        chequeType: "OTM",
    }
    //, for biller option will not come for nri -otm pan
    // {
    //     name: "Netbanking + Add Biller",
    //     mode: 'DCB',
    //     image: Icon1,
    //     chequeType: "DCB",
    // }
]

export const RS = '₹';

// Custom email validation with additional checks
export const validateEmail = (email) => {
    if (!email) return "Email is required";
    
    // Check for consecutive dots
    if (/\.{2,}/.test(email)) return "Consecutive dots are not allowed";
    
    // Check for forbidden special characters
    if (/[+=%-]/.test(email)) return "Special characters like +, =, %, - are not allowed";
    
    // Basic email format validation
    if (!regEx.email.test(email)) return "Please enter a valid email address";
    
    return ""; // Valid email
};

export const impNoteForPayment = {
    "DCB": {
        note: `Bank which does not have netbanking facility ( eg Citibank or any PSU Banks) cannot use this
    option.Please choose UPI or NEFT | RTGS for your payment towards this investment.`
    },
    "UPI": {
        note: `Please use your bank handle for your UPI transaction. Do not make payment using 3rd party UPI 
    handle like Google pay or Paytm Money, your amount may get deducted but it will be refunded back due 
    to TPV validation failure as a regulatory check.
    In case your amount gets debited from your bank account and you do not receive transaction 
    confirmation message back on MOAMC, you will receive email/sms once we realize the funds 
    this majorly happens because of the payment realization response time-lag from your bank.`
    },
    "Mandate": {
        note: `Bank which does not have netbanking facility ( eg Citibank or any PSU Banks) cannot use this
    option.Please choose UPI or NEFT | RTGS for your payment towards this investment.`
    },
    "OTM": {
        note: `Unit allotment will be subject to receipt of funds in the mutual fund account`
    },
    "biller": {
        note: `Your sip debit request would be registered against the selected banks active URN. You would receive the URN no on email once you complete the transaction.`
    }
}

export const infoIconCalc = {
    invtAmt: `Lump sum amount you want to invest.`,
    withDrawFreq: `The frequency at which your withdrawal amount will be credited to your registered bank account`,
    startDate: `You will start receiving your withdrawal amount from this date.`,
    tenure: `Your withdrawal will continue for the selected tenure from the start date.`,
    withDrawPerc: `Percentage of amount you wish to withdraw annually from your investment amount`,
    expRtn: `Your expected returns on the investment for the selected tenure.`,
    withDrawAmt: `Fixed amount you want to receive as your regular monthly income`,
}

export const investOrderReviewColWidth = {
    lumpsum: {
        fund: 45,
        plan: 15,
        type: 10,
        amount: 15,
        action: 15
    },
    sip: {
        fund: 30,
        plan: 10,
        type: 10,
        date: 10,
        frequency: 10,
        noOfInstallment: 10,
        amount: 10,
        action: 10
    }
}

export const userTypeList = ["NRI-REPATRIABLE", "NRI-NON-REPATRIABLE", "NRO-REPATRIABLE", "NRO-NON-REPATRIABLE"]

export const masterMenuOptions = [
    {
        "menu": {
            "label": "My Portfolio",
            "linkTo": "/portfolio",
            "class": "myportfolio_navicon",
            "mainMenuId": 1
        }
    },
    {
        "menu": {
            "label": "Start SIP",
            "linkTo": "/sip/select-fund",
            "class": "invest_navicon_sip",
            "mainMenuId": 2
        }
    },
    {
        "menu": {
            "label": "Lumpsum",
            "linkTo": "/transact/lumpsum-invested-funds",
            "class": "invest_navicon",
            "mainMenuId": 3
        }
    },
    {
        "menu": {
            "label": "Other Transactions",
            "linkTo": "",
            "class": "invest_navicon_othertrans",
            "mainMenuId": 4
        },
        "subMenu": [
            // {
            //     "menu": {
            //         "label": "Quick Invest",
            //         "linkTo": "/transact/quick-invest",
            //         "class": "xyz",
            //         "mainMenuId": 4,
            //         "submenuOrder": 1,
            //     }
            // },
            {
                "menu": {
                    "label": "FAB Plan",
                    "linkTo": "/fab-plan/scheme-selection",
                    "class": "xyz",
                    "mainMenuId": 4,
                    "submenuOrder": 2,
                }
            },
            {
                "menu": {
                    "label": "Create Folio",
                    "linkTo": "/onboarding/personal",
                    "class": "xyz",
                    "mainMenuId": 4,
                    "submenuOrder": 3,
                }
            },
            {
                "menu": {
                    "label": "Withdraw - Once",
                    "linkTo": "/transact/sell",
                    "class": "_ac",
                    "mainMenuId": 4,
                    "submenuOrder": 4,
                }
            },
            {
                "menu": {
                    "label": "Withdraw - SWP",
                    "linkTo": "/transact/SWP",
                    "class": "_ac",
                    "mainMenuId": 4,
                    "submenuOrder": 5,
                }
            },
            {
                "menu": {
                    "label": "Switch - Once",
                    "linkTo": "/transact/switch",
                    "class": "_ac",
                    "mainMenuId": 4,
                    "submenuOrder": 6,
                }
            },
            {
                "menu": {
                    "label": "Switch - STP",
                    "linkTo": "/transact/stp",
                    "class": "_ac",
                    "mainMenuId": 4,
                    "submenuOrder": 7,
                }
            }
        ]
    },
    // {
    //     "menu": {
    //         "label": "Redemption",
    //         "linkTo": "",
    //         "class": "redemption_navicon",
    //         "mainMenuId": 3
    //     },
    //     "subMenu": [
    //         {
    //             "menu": {
    //                 "label": "Sell",
    //                 "linkTo": "/transact/sell",
    //                 "class": "_ac",
    //                 "submenuOrder": 1,
    //                 "mainMenuId": 3
    //             }
    //         },
    //         {
    //             "menu": {
    //                 "label": "SWP",
    //                 "linkTo": "/transact/SWP",
    //                 "class": "_ac",
    //                 "submenuOrder": 2,
    //                 "mainMenuId": 3
    //             }
    //         },
    //         //   {
    //         //       "menu": {
    //         //           "label": "Loan Against MF",
    //         //           "linkTo": "/las",
    //         //           "class": "_ac",
    //         //           "submenuOrder": 3,
    //         //           "mainMenuId": 3
    //         //       }
    //         //   }
    //     ]
    // },
    // {
    //     "menu": {
    //         "label": "Transfer",
    //         "linkTo": "",
    //         "class": "transfer_navicon",
    //         "mainMenuId": 4
    //     },
    //     "subMenu": [
    //         {
    //             "menu": {
    //                 "label": "Switch",
    //                 "linkTo": "/transact/switch",
    //                 "class": "_ac",
    //                 "submenuOrder": 1,
    //                 "mainMenuId": 4
    //             }
    //         },
    //         {
    //             "menu": {
    //                 "label": "STP",
    //                 "linkTo": "/transact/stp",
    //                 "class": "_ac",
    //                 "submenuOrder": 2,
    //                 "mainMenuId": 4
    //             }
    //         }
    //     ]
    // },
    {
        "menu": {
            "label": "Scheduled Investments",
            "linkTo": "",
            "class": "mnschedule_navicon",
            "mainMenuId": 5
        },
        "subMenu": [
            {
                "menu": {
                    "label": "SIP",
                    "linkTo": "/schedule-investments/sip",
                    "class": "_ac",
                    "submenuOrder": 1,
                    "mainMenuId": 5
                }
            },
            {
                "menu": {
                    "label": "SWP",
                    "linkTo": "/schedule-investments/swp",
                    "class": "_ac",
                    "submenuOrder": 2,
                    "mainMenuId": 5
                }
            },
            {
                "menu": {
                    "label": "STP",
                    "linkTo": "/schedule-investments/stp",
                    "class": "_ac",
                    "submenuOrder": 3,
                    "mainMenuId": 5
                }
            }
        ]
    },
    {
        "menu": {
            "label": "Orderbook",
            "linkTo": "/orderbook",
            "class": "orderbook_navicon",
            "mainMenuId": 6
        }
    },
    {
        "menu": {
            "label": "Reports",
            "linkTo": "",
            "class": "manageac_navicon",
            "mainMenuId": 7
        },
        "subMenu": [
            {
                "menu": {
                    "label": "SIP Reports",
                    "linkTo": "/reports/sip-report",
                    "class": "_ac",
                    "submenuOrder": 1,
                    "mainMenuId": 7
                }
            },
            {
                "menu": {
                    "label": "Capital Gain / Loss Statement",
                    "linkTo": "/reports/capital-gain-loss",
                    "class": "_ac",
                    "submenuOrder": 2,
                    "mainMenuId": 7
                }
            },
            {
                "menu": {
                    "label": "Account Statement",
                    "linkTo": "/reports/account-statement",
                    "class": "_ac",
                    "submenuOrder": 3,
                    "mainMenuId": 7
                }
            },
            {
                "menu": {
                    "label": "ELSS Reports",
                    "linkTo": "/reports/elss",
                    "class": "_ac",
                    "submenuOrder": 4,
                    "mainMenuId": 7
                }
            }
        ]
    },
    {
        "menu": {
            "label": "Manage Account",
            "linkTo": "",
            "class": "manageac_navicon",
            "mainMenuId": 8
        },
        "subMenu": [
            {
                "menu": {
                    "label": "Manage Bank",
                    "linkTo": "/manage-account/add-new-bank",
                    "class": "_ac",
                    "submenuOrder": 1,
                    "mainMenuId": 8
                }
            },
            {
                "menu": {
                    "label": "Add Mandate",
                    "linkTo": "/manage-account/add-new-mandate",
                    "class": "_ac",
                    "submenuOrder": 2,
                    "mainMenuId": 8
                }
            },
            {
                "menu": {
                    "label": "Add E-Mandate",
                    "linkTo": "/manage-account/emandate",
                    "class": "_ac",
                    "submenuOrder": 3,
                    "mainMenuId": 8
                }
            },
            {
                "menu": {
                    "label": "UPI Mandate",
                    "linkTo": "/manage-account/upimandate",
                    "class": "_ac",
                    "submenuOrder": 4,
                    "mainMenuId": 8
                }
            },
            {
                "menu": {
                    "label": "Add Nominee",
                    "linkTo": "/manage-account/nomineemanage",
                    "class": "_ac",
                    "submenuOrder": 5,
                    "mainMenuId": 8
                }
            }
        ]
    }
]

export const menuRoleWiseOptions = [
    {
        "menu": {
            "label": "My Portfolio",
            "linkTo": "/portfolio",
            "class": "myportfolio_navicon",
            "mainMenuId": 1
        }
    },
    {
        "menu": {
            "label": "Invest",
            "linkTo": "",
            "class": "invest_navicon",
            "mainMenuId": 2
        },
        "subMenu": [
            {
                "menu": {
                    "label": "Quick Invest",
                    "linkTo": "/transact/quick-invest",
                    "class": "xyz",
                    "submenuOrder": 1,
                    "mainMenuId": 2
                }
            },
            {
                "menu": {
                    "label": "Lumpsum",
                    "linkTo": "/transact/lumpsum-invested-funds",
                    "class": "xyz",
                    "submenuOrder": 2,
                    "mainMenuId": 2
                }
            },
            {
                "menu": {
                    "label": "Lumpsum - Cashflow",
                    "linkTo": "/transact/lumpsum-cashflow",
                    "class": "xyz",
                    "submenuOrder": 3,
                    "mainMenuId": 2
                }
            },
            {
                "menu": {
                    "label": "SIP",
                    "linkTo": "/sip/select-fund",
                    "class": "xyz",
                    "submenuOrder": 4,
                    "mainMenuId": 2
                }
            },
            {
                "menu": {
                    "label": "FAB Plans",
                    "linkTo": "/fab-plan/scheme-selection",
                    "class": "xyz",
                    "submenuOrder": 5,
                    "mainMenuId": 2
                }
            }
        ]
    },
    {
        "menu": {
            "label": "Redemption",
            "linkTo": "",
            "class": "redemption_navicon",
            "mainMenuId": 3
        },
        "subMenu": [
            {
                "menu": {
                    "label": "Sell",
                    "linkTo": "/transact/sell",
                    "class": "_ac",
                    "submenuOrder": 1,
                    "mainMenuId": 3
                }
            },
            {
                "menu": {
                    "label": "SWP",
                    "linkTo": "/transact/SWP",
                    "class": "_ac",
                    "submenuOrder": 2,
                    "mainMenuId": 3
                }
            }
        ]
    },
    {
        "menu": {
            "label": "Transfer",
            "linkTo": "",
            "class": "transfer_navicon",
            "mainMenuId": 4
        },
        "subMenu": [
            {
                "menu": {
                    "label": "Switch",
                    "linkTo": "/transact/switch",
                    "class": "_ac",
                    "submenuOrder": 1,
                    "mainMenuId": 4
                }
            },
            {
                "menu": {
                    "label": "STP",
                    "linkTo": "/transact/stp",
                    "class": "_ac",
                    "submenuOrder": 2,
                    "mainMenuId": 4
                }
            }
        ]
    },
    {
        "menu": {
            "label": "Scheduled Investments",
            "linkTo": "",
            "class": "mnschedule_navicon",
            "mainMenuId": 5
        },
        "subMenu": [
            {
                "menu": {
                    "label": "SIP",
                    "linkTo": "/schedule-investments/sip",
                    "class": "_ac",
                    "submenuOrder": 1,
                    "mainMenuId": 5
                }
            },
            {
                "menu": {
                    "label": "SWP",
                    "linkTo": "/schedule-investments/swp",
                    "class": "_ac",
                    "submenuOrder": 2,
                    "mainMenuId": 5
                }
            },
            {
                "menu": {
                    "label": "STP",
                    "linkTo": "/schedule-investments/stp",
                    "class": "_ac",
                    "submenuOrder": 3,
                    "mainMenuId": 5
                }
            }
        ]
    },
    {
        "menu": {
            "label": "Orderbook",
            "linkTo": "/orderbook",
            "class": "orderbook_navicon",
            "mainMenuId": 6
        }
    },
    {
        "menu": {
            "label": "Reports",
            "linkTo": "",
            "class": "manageac_navicon",
            "mainMenuId": 7
        },
        "subMenu": [
            {
                "menu": {
                    "label": "SIP Reports",
                    "linkTo": "/reports/sip-report",
                    "class": "_ac",
                    "submenuOrder": 1,
                    "mainMenuId": 7
                }
            },
            {
                "menu": {
                    "label": "Capital Gain / Loss Statement",
                    "linkTo": "/reports/capital-gain-loss",
                    "class": "_ac",
                    "submenuOrder": 2,
                    "mainMenuId": 7
                }
            },
            {
                "menu": {
                    "label": "Account Statement",
                    "linkTo": "/reports/account-statement",
                    "class": "_ac",
                    "submenuOrder": 3,
                    "mainMenuId": 7
                }
            },
            {
                "menu": {
                    "label": "ELSS Reports",
                    "linkTo": "/reports/elss",
                    "class": "_ac",
                    "submenuOrder": 4,
                    "mainMenuId": 7
                }
            }
        ]
    },
    {
        "menu": {
            "label": "Manage Account",
            "linkTo": "",
            "class": "manageac_navicon",
            "mainMenuId": 8
        },
        "subMenu": [
            {
                "menu": {
                    "label": "Manage Bank",
                    "linkTo": "/manage-account/add-new-bank",
                    "class": "_ac",
                    "submenuOrder": 1,
                    "mainMenuId": 8
                }
            },
            {
                "menu": {
                    "label": "Add Mandate",
                    "linkTo": "/manage-account/add-new-mandate",
                    "class": "_ac",
                    "submenuOrder": 2,
                    "mainMenuId": 8
                }
            },
            {
                "menu": {
                    "label": "Add E-Mandate",
                    "linkTo": "/manage-account/emandate",
                    "class": "_ac",
                    "submenuOrder": 3,
                    "mainMenuId": 8
                }
            },
            {
                "menu": {
                    "label": "UPI Mandate",
                    "linkTo": "/manage-account/upimandate",
                    "class": "_ac",
                    "submenuOrder": 4,
                    "mainMenuId": 8
                }
            },
            {
                "menu": {
                    "label": "Add Nominee",
                    "linkTo": "/manage-account/nomineemanage",
                    "class": "_ac",
                    "submenuOrder": 5,
                    "mainMenuId": 8
                }
            }
        ]
    }
];

export const ISIPDebitLine = "Note: SIP will be registered on OTP authentication even if the initial debit fails"
export const sipMandateMaxYear = 29;
export const upiMandateMaxYear = 29;
export const otpMasterType = {
    transactionType: "TransactionOTP",
    loginType: "LoginOTP",

    //tranact
    switchType: "SwitchOTP",
    stpType: "STPOTP",

    // redeem
    swpType: "SWPOTP",
    redeemType: "RedeemOTP",//sell
    addNewBank: "AddNewBank",
    changePrimaryBank: "ChangePrimaryBank",
}

export const successResponse = {
    responseTitle: 'Your order has been initiated successfully',
    responseMsg: `Your transaction has been placed successfully.${'\n'}You will be able to see your status in Profile under Transactions `,
    buttonText: 'Buy another Fund',
    clearStack: true,
    status: 'success',
    buttonScreen: 'Funds',
    showButton: true,
    autoRedirect: false,
};

export const failureResponse = {
    status: 'fail',
    responseTitle: `Sorry, the payment${'\n'}couldnt be completed`,
    responseMsg: `Your Transactions failed, please try again`,
    buttonScreen: 'Funds',
    showButton: true,
    autoRedirect: false,
};

export const isipPaymentModeOptions = [
    { value: 'Net Banking + Autopay', label: 'Net Banking + Auto Pay' },
    { value: 'UPI + Auto Pay', label: 'UPI + Auto Pay' },
    { value: 'Auto Pay', label: 'Auto Pay' },
];

export const nroisipPaymentModeOptions = [
    { value: 'biller', label: 'Net Banking + Biller' },
    { value: 'UPI + Biller', label: 'UPI + Biller' }
];

export const nroisipwithotmPaymentModeOptions = [
    { value: 'Net Banking + Autopay', label: 'Net Banking + Auto Pay' },
    { value: 'UPI + Auto Pay', label: 'UPI + Auto Pay' }
];


export const autoPayOption = [
    { value: 'Auto Pay', label: 'Auto Pay' }
];

export const MandatePaymentOptions = [
    { value: 'Net Banking', label: 'Net Banking' },
    // { value: 'Debit Card', label: 'Debit Card' }
];

export const MenuProps = {
    PaperProps: {
        style: {
            width: 350,
        },
    },
};

export const sx = {
    width: '400px',
};

export const paymentContinueButtonStyle = {
    backgroundColor: '#E63A46',
    color: '#fff',
    fontFamily: ['Work Sans', 'sans-serif'].join(','),
    boxShadow: 'none',
    textTransform: 'inherit',
    paddingTop: '8px',
    paddingBottom: '8px'
};

export const desktopPaymentContinueButtonStyle = {
    backgroundColor: '#E63A46',
    color: '#fff',
    fontFamily: ['Work Sans', 'sans-serif'].join(','),
    boxShadow: 'none',
    textTransform: 'inherit',
    paddingLeft: '10px',
    paddingRight: '10px'
};

export const paymentBackButtonStyle = {
    backgroundColor: 'transparent',
    color: '#E63A46',
    fontFamily: ['Work Sans', 'sans-serif'].join(','),
    boxShadow: 'none',
    textTransform: 'inherit',
    padding: '8px 30px'
};

export const desktopAddSipButtonStyle = {
    backgroundColor: '#E63A46',
    color: '#fff',
    fontFamily: ['Work Sans', 'sans-serif'].join(','),
    boxShadow: 'none',
    textTransform: 'inherit',
    paddingRight: '5vw',
    paddingLeft: '5vw',
};

export const desktopBackButtonStyle = {
    fontFamily: ['Work Sans', 'sans-serif'].join(','),
    textTransform: 'inherit',
    paddingRight: '30px',
    paddingLeft: '30px',
};

export const mobileAddSipButtonStyle = {
    backgroundColor: '#E63A46',
    color: '#fff',
    fontFamily: ['Work Sans', 'sans-serif'].join(','),
    boxShadow: 'none',
    textTransform: 'inherit',
    paddingTop: '10px',
    paddingRight: '40px',
    paddingLeft: '40px',
    paddingBottom: '10px'
};

export const mobileBackButtonStyle = {
    fontFamily: ['Work Sans', 'sans-serif'].join(','),
    textTransform: 'inherit',
    paddingTop: '10px',
    paddingRight: '30px',
    paddingLeft: '30px',
    paddingBottom: '10px'
};

export const NFOSchemeCode = '';
export const NFOReopenDate = '';
export const NFOSchemeName = '';

export const basketSchemes = {
    sip: [
        {
            name: "Motilal Oswal Multi Cap Fund",
            schemeCode: 'MM',
            amount: 700,
            frequency: 'Monthly',
            startDate: "2024-11-01",
            endDate: '2063-11-01',
            noOfInstallments: 469,
            planType: 'Direct',
            isip: true,
            type: 'SIP',
            option: "G",
            plan: 'GD',
            siptype: 'SIP'
        },
        {
            name: "Motilal Oswal Small Cap Fund",
            schemeCode: 'SC',
            amount: 500,
            frequency: 'Monthly',
            startDate: "2024-11-01",
            endDate: '2063-11-01',
            noOfInstallments: 469,
            planType: 'Direct',
            isip: true,
            option: "G",
            plan: 'GD',
            siptype: 'SIP'
        },
        {
            name: "Motilal Oswal Large and Midcap Fund",
            schemeCode: 'LM',
            amount: 1500,
            frequency: 'Monthly',
            startDate: "2024-11-01",
            endDate: '2063-11-01',
            noOfInstallments: 469,
            planType: 'Direct',
            isip: true,
            option: "G",
            plan: 'GD',
            siptype: 'SIP'
        },
        {
            name: "Motilal Oswal Midcap Fund",
            schemeCode: 'FM',
            amount: 1000,
            frequency: 'Monthly',
            startDate: "2024-11-01",
            endDate: '2063-11-01',
            noOfInstallments: 469,
            planType: 'Direct',
            isip: true,
            option: "G",
            plan: 'GD',
            siptype: 'SIP'
        }
    ],
    lumpsum: [
        {
            name: "Motilal Oswal Multi Cap Fund",
            schemeCode: 'MM',
            amount: 3000,
            planType: 'Direct',
            isip: true,
            option: "G",
            plan: 'GD',

        },
        {
            name: "Motilal Oswal Small Cap Fund",
            schemeCode: 'SC',
            amount: 4000,
            planType: 'Direct',
            isip: true,
            option: "G",
            plan: 'GD',
        },
        {
            name: "Motilal Oswal Midcap Fund",
            schemeCode: 'FM',
            amount: 2000,
            planType: 'Direct',
            isip: true,
            option: "G",
            plan: 'GD',

        },
        {
            name: "Motilal Oswal Large and Midcap Fund",
            schemeCode: 'LM',
            amount: 1000,
            planType: 'Direct',
            isip: true,
            option: "G",
            plan: 'GD',

        },
    ],
};



// ===================================================================
// NFO CHANGE START (To disable NFO changes, change NFO_IS_ACTIVE to false, and pass empty string in NFO_SCHEME_CODE)
// ===================================================================
export const NFO_DATA = {
    NFO_IS_ACTIVE: false,
    NFO_IS_SMART_SWITCH_ACTIVE: false,
    NFO_START_DATE: "2026-02-20",
	NFO_END_DATE: "2026-03-07", // T + 1
	NFO_END_DATE_TEXT: "6th March, 2026",
    NFO_ALLOTMENT_DATE: "2026-03-12", // YYYY-MM-DD
    NFO_ALLOTMENT_DATE_TEXT: "12th March, 2026",
    NFO_REOPEN_DATE: "2026-03-18", // YYYY-MM-DD
    NFO_SCHEME_NAME: "Motilal Oswal Multi Factor Passive Fund of Funds",
    NFO_SCHEME_CODE: "",
    NFO_LANDING_PAGE_URL: "motilal-oswal-multi-factor-passive-fund-of-funds", // url after mutual-funds/ to redirect to fund landing page
    NFO_PASSCODE_GIF_SRC: "login/multi-factor-passcode-340x340.gif",
    NFO_CARD_BANNER: "category/multi-factor-card-banner.png",
    NFO_CHECKOUT_CART_BANNER: "category/NFO_PostLogin_Multi_Factor_Passive_FoF_Hero_desktop.jpg",
    NFO_CHECKOUT_CART_BANNER_MOBILE: "category/NFO_PostLogin_Multi_Factor_Passive_FoF_Hero_Mobile.jpg",
    NFO_UTM_SOURCE_DESKTOP : "utm_source=Desktop&utm_medium=Header&utm_campaign=multi_factor_passive",
	NFO_UTM_SOURCE_MOBILE : "utm_source=Mobile&utm_medium=Header&utm_campaign=multi_factor_passive"
}
// ===================================================================
// NFO CHANGE END
// ===================================================================

export const IdentityProof = [
    { value: 'Pan Number', label: 'PAN Number' },
    { value: 'Driving Licence', label: 'Driving Licence' },
    { value: 'Aadhar Number', label: 'Aadhar Number' },
    { value: 'Passport', label: 'Passport' },
];
    // { value: 'Aadhaar Number', label: 'Aadhaar Number' },

export const ordinalNames = ["first", "second", "third", "fourth", "fifth", "sixth", "seventh", "eighth", "ninth", "tenth"];

//#region Journey Types that skip passcode page (PAN + OTP only)
// Distributor Journey Platform
// DJPLP = Distributor Journey Platform Purchase Lumpsum
// DJPSP = Distributor Journey Platform Purchase SIP
// DJPCR = Distributor Journey Platform Purchase CART
// Quick Buy
// QBLP = Quick Buy Lumpsum
// QBSP = Quick Buy SIP
// QBSS = Quick Buy Smart Switch
// Prelogin
// PLP = Prelogin Lumpsum
// PSP = Prelogin SIP
// PSS = Prelogin Smart Switch
// CBC = Combined CART
// Postlogin
// POLP = Postlogin Lumpsum
// POSP = Postlogin SIP
// POSS = Postlogin Smart Switch
// Distributor Common Link
// DCLP = Distributor common Link Lumpsum
// DCSP = Distributor common Link SIP
// DCSS = Distributor common Link Smart Switch
export const SKIP_PASSCODE_JOURNEY_TYPES = [
    'DJPLP', 'DJPSP', 'DJPCR',
    'QBLP', 'QBSP', 'QBSS',
    'PLP', 'PSP', 'PSS', 'CBC',
    'POLP', 'POSP', 'POSS',
    'DCLP', 'DCSP', 'DCSS',
];

export const isSkipPasscodeJourney = (searchString) => {
    const params = new URLSearchParams(searchString);
    const journeyType = params.get('journeyType');
    const isRetry = params.get('isRetry');
    const isQuickLink = params.get('quickLink');
    if(isQuickLink){
        return true;
    }
    if (!journeyType || !SKIP_PASSCODE_JOURNEY_TYPES.includes(journeyType)) return false;
    return isRetry === 'true';
};
//#endregion

// Datadog Configuration
export const DATADOG_CONFIG = {
    CLIENT_TOKEN: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
    APPLICATION_ID: process.env.REACT_APP_DATADOG_APPLICATION_ID,
    SITE: process.env.REACT_APP_DATADOG_SITE,
    SERVICE: process.env.REACT_APP_DATADOG_SERVICE,
    ENV: process.env.REACT_APP_DATADOG_ENV,
    SESSION_SAMPLE_RATE: parseInt(process.env.REACT_APP_DATADOG_SESSION_SAMPLE_RATE) || 100,
    SESSION_REPLAY_SAMPLE_RATE: parseInt(process.env.REACT_APP_DATADOG_SESSION_REPLAY_SAMPLE_RATE) || 20
};
